module.exports = __webpack_public_path__ + "img/Rainbow_Rod_demo.cbab76b7.gif";